import { render, staticRenderFns } from "./EducationalQualifications.vue?vue&type=template&id=4b0df10e&scoped=true&"
import script from "./EducationalQualifications.vue?vue&type=script&lang=js&"
export * from "./EducationalQualifications.vue?vue&type=script&lang=js&"
import style0 from "./EducationalQualifications.vue?vue&type=style&index=0&id=4b0df10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0df10e",
  null
  
)

export default component.exports